import script from "./VoiceDownload.vue?vue&type=script&setup=true&lang=js"
export * from "./VoiceDownload.vue?vue&type=script&setup=true&lang=js"

import "./VoiceDownload.vue?vue&type=style&index=0&id=0a09dbd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a09dbd3"]])

export default __exports__